import * as React from 'react'
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import { Input, InputProps } from '@mui/material';
import {EnterKeyHandlerProps, withEnterKeyHandler} from './hoc/withEnterKeyHandler'

const PPInput = (props: InputProps & ErrorHandlingFormProps & EnterKeyHandlerProps) => {
    const {hasError, messages, clearErrorMessage, eventKeys, eventEmitter, ...rest} = props
    return <Input
        {...rest}
        error={hasError}
    />
}
PPInput.displayName = 'PPInput'
export default createErrorHandlingForm(withEnterKeyHandler(PPInput))
